"use client";

import { useHolidayQuoteBrand } from "../contexts/use-holiday-quote-brand";
import { getQuoteThemeClassNames } from "./quote-theme-class-maps";

export function useQuoteTheme() {
  const { quoteTheme } = useHolidayQuoteBrand();
  const classNames = getQuoteThemeClassNames(
    quoteTheme.uiStyle,
    quoteTheme.config.colorSchema
  );

  return {
    ...quoteTheme,
    classNames,
  };
}
